import { render } from "./edit-appointment.vue?vue&type=template&id=7bd95e0b"
import script from "./edit-appointment.vue?vue&type=script&lang=js"
export * from "./edit-appointment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__